import { CascadingMenuItem } from '../../../components/cascading-menu/cascading-menu-item';
import { Database } from '../../../shared/database.enum';
import { SubIndex } from '../../../shared/sub-index.enum';
import { UserType } from '../filters/user-type.enum';
import { User } from './user.enum';

export const userTypes: CascadingMenuItem[] = [
  { value: User.Breeder, label: User.Breeder, id: UserType.Breeder },
  { value: User.Buyer, label: User.Buyer, id: UserType.Buyer },
  { value: User.ServiceProvider, label: User.ServiceProvider, id: UserType.ServiceProvider },
];

// export const databaseTypes: CascadingMenuItem[] = [
const databaseTypes: CascadingMenuItem[] = [
  {
    value: 'Merinos',
    label: 'Merinos',
    id: Database.Merino,
  },
  {
    id: 'Terminal breeds',
    label: 'Terminal breeds',
    value: 'Terminal breeds',
    subOptions: [
      { value: 'Terminal breeds - all', label: 'All', id: Database.TerminalAll },
      { value: 'Terminal breeds - shedders', label: 'Shedders', id: Database.TerminalShedders },
    ],
  },
  {
    id: 'Maternal breeds',
    label: 'Maternal breeds',
    value: 'Maternal breeds',
    subOptions: [
      { value: 'Maternal breeds - all', label: 'All', id: Database.MaternalAll },
      { value: 'Maternal breeds - first cross sire breeds', label: 'First cross sire breeds', id: Database.MaternalFirstCrossSire },
      { value: 'Maternal breeds - Corriedales', label: 'Corriedales', id: Database.MaternalCorriedale },
      { value: 'Maternal breeds - Prime SAMM', label: 'Prime SAMM', id: Database.MaternalPrimeSAMMs },
    ],
  },
  {
    value: 'Dohnes',
    label: 'Dohnes',
    id: Database.Dohne,
  },
  {
    value: 'Goats',
    label: 'Goats',
    id: Database.Boer,
  },
  // *TEMA* Starts
  {
    value: 'Combined LAMBPLAN (Research Analysis)',
    label: 'Combined LAMBPLAN (Research Analysis)',
    id: 'Combined Lambplan (Research Analysis)',
    subOptions: [
      { value: 'Combined LAMBPLAN - All', label: 'All', id: Database.LambplanAll },
      { value: 'CL-Terminal sire breeds', label: 'CL-Terminal sire breeds', id: Database.LambplanTerminal },
      { value: 'CL-Maternal sire breeds', label: 'CL-Maternal sire breeds', id: Database.LambplanMaternal },
      { value: 'CL-FirstCross sire breeds', label: 'CL-FirstCross sire breeds', id: Database.LambplanFirstCross },
      { value: 'CL-Corriedale breeds', label: 'CL-Corriedale', id: Database.LambplanCorriedale },
      { value: 'CL-Shedding breeds', label: 'CL-Shedders', id: Database.LambplanShedders },
    ],
  },
  // *TEMA* End
];

// If TEMA flag is false do not include the TEMA databaseType which is 'Combined Lambplan (Research Analysis)'
const filteredDatabaseTypes = process.env.REACT_APP_FEATURE_TEMA === 'false'
  ? databaseTypes.filter((item) => item.value !== 'Combined LAMBPLAN (Research Analysis)')
  : databaseTypes;

export { filteredDatabaseTypes as databaseTypes };

export const getObjectives = (database: Database) => {
  const objectives = [
    // Terminal
    {
      value: 'TCP Index - Maintaining eating quality and improving carcase, growth',
      label: 'Maintaining eating quality and improving carcase, growth',
      id: SubIndex.MaintainingEQ,
      db: Database.TerminalAll,
    },
    {
      value: 'EQ Index - Improving eating quality, carcase, growth',
      label: 'EQ Index - Improving eating quality, carcase, growth',
      id: SubIndex.ImprovingEQ,
      db: Database.TerminalAll,
    },
    {
      value: 'LEQ Index - Improving worm resistance, improving eating quality, carcase, growth',
      label: 'LEQ Index - Improving worm resistance, improving eating quality, carcase, growth',
      id: SubIndex.ImprovingWorm,
      db: Database.TerminalAll,
    },
    {
      value: 'Carcase, growth',
      label: 'Carcase, growth',
      id: SubIndex.CarcaseGrowth,
      db: Database.TerminalShedders,
    },
    {
      value: 'Reproduction, carcase, growth',
      label: 'Reproduction, carcase, growth',
      id: SubIndex.ReproductionCarcaseGrowth,
      db: Database.TerminalShedders,
    },
    // Merino
    {
      value: 'FW Index - Breeding finer wool',
      label: 'FW Index - Breeding finer wool',
      id: SubIndex.FineWool,
      db: Database.Merino,
    },
    {
      value: 'WP Index - Increased wool production',
      label: 'WP Index - Increased wool production',
      id: SubIndex.WoolProduction,
      db: Database.Merino,
    },
    {
      value: 'SM Index - Balanced wool and meat with a focus on welfare',
      label: 'SM Index - Balanced wool and meat with a focus on welfare',
      id: SubIndex.SustainableMerino,
      db: Database.Merino,
    },
    {
      value: 'ML Index - Prime lamb production from Merino ewes',
      label: 'ML Index - Prime lamb production from Merino ewes',
      id: SubIndex.MerinoLamb,
      db: Database.Merino,
    },
    // Combined Lambplan
    {
      value: 'TCP – maintain EQ & improve carcase and improving carcase and growth',
      label: 'TCP – maintain EQ & improve carcase',
      id: SubIndex.ClMaintainingEQ,
      db: Database.LambplanAll,
    },
    {
      value: 'EQ - Improving eating quality carcase growth',
      label: 'EQ – improve EQ & carcase',
      id: SubIndex.ClImprovingEQ,
      db: Database.LambplanAll,
    },
    {
      value: 'LEQ - Improving worm resistance eating quality carcase and growth',
      label: 'LEQ – improve worm resistance, EQ, carcase',
      id: SubIndex.ClImprovingWorm,
      db: Database.LambplanAll,
    },
    {
      value: 'BLX - Rams joined to Merino ewes to produce first cross progeny',
      label: 'BLX - Rams joined to Merino ewes',
      id: SubIndex.ClRamsJoinedToMerino,
      db: Database.LambplanAll,
    },
    {
      value: 'MCP - Self replacing maternal flock',
      label: 'MCP - Self replacing maternal flock',
      id: SubIndex.ClSelfReplacingMAT,
      db: Database.LambplanAll,
    },
    {
      value: 'MCP+ - Self replacing maternal flock aimed to improve worm resistance and fleece weight',
      label: 'MCP+ – self replacing maternal improve worm resistance & fleece weight',
      id: SubIndex.ClSelfReplacingWormMAT,
      db: Database.LambplanAll,
    },
    {
      value: 'MWP+ - Self replacing maternal flock aiming to improve wool quality',
      label: 'MWP+ – self replacing maternal improve wool quality',
      id: SubIndex.ClSelfReplacingWoolMAT,
      db: Database.LambplanAll,
    },
    // Combined Lambplan - TERM
    {
      value: 'TCP – maintain EQ & improve carcase and improving carcase and growth',
      label: 'TCP – maintain EQ & improve carcase',
      id: SubIndex.ClTermMaintainingEQ,
      db: Database.LambplanTerminal,
    },
    {
      value: 'EQ – improve EQ & carcase carcase growth',
      label: 'EQ – improve EQ & carcase',
      id: SubIndex.ClTermImprovingEQ,
      db: Database.LambplanTerminal,
    },
    {
      value: 'LEQ - Improving worm resistance eating quality carcase and growth',
      label: 'LEQ – improve worm resistance, EQ, carcase',
      id: SubIndex.ClTermImprovingWorm,
      db: Database.LambplanTerminal,
    },
    // Combined Lambplan - MAT
    {
      value: 'BLX - Rams joined to Merino ewes to produce first cross progeny',
      label: 'BLX - Rams joined to Merino ewes',
      id: SubIndex.ClMatRamsJoinedToMerino,
      db: Database.LambplanMaternal,
    },
    {
      value: 'MCP - Self replacing maternal flock',
      label: 'MCP - Self replacing maternal flock',
      id: SubIndex.ClMatSelfReplacingMAT,
      db: Database.LambplanMaternal,
    },
    {
      value: 'MCP+ - Self replacing maternal flock aimed to improve worm resistance and fleece weight',
      label: 'MCP+ – self replacing maternal improve worm resistance & fleece weight',
      id: SubIndex.ClMatSelfReplacingWormMAT,
      db: Database.LambplanMaternal,
    },
    {
      value: 'MWP+ - Self replacing maternal flock aiming to improve wool quality',
      label: 'MWP+ – self replacing maternal improve wool quality',
      id: SubIndex.ClMatSelfReplacingWoolMAT,
      db: Database.LambplanMaternal,
    },
    // Combined Lambplan - FC
    {
      value: 'BLX - Rams joined to Merino ewes to produce first cross progeny',
      label: 'BLX - Rams joined to Merino ewes',
      id: SubIndex.ClFcRamsJoinedToMerino,
      db: Database.LambplanFirstCross,
    },
    // Combined Lambplan - CORR
    {
      value: 'MWP+ - Self replacing maternal flock aiming to improve wool quality',
      label: 'MWP+ – self replacing maternal improve wool quality',
      id: SubIndex.ClCorrSelfReplacingWoolMAT,
      db: Database.LambplanCorriedale,
    },
    // Combined Lambplan - SHEDD
    {
      value: 'TCP – maintain EQ & improve carcase and improving carcase and growth',
      label: 'TCP – maintain EQ & improve carcase',
      id: SubIndex.ClSheddMaintainingEQ,
      db: Database.LambplanShedders,
    },
    {
      value: 'EQ – improve EQ & carcase carcase growth',
      label: 'EQ – improve EQ & carcase',
      id: SubIndex.ClSheddImprovingEQ,
      db: Database.LambplanShedders,
    },
    {
      value: 'LEQ - Improving worm resistance eating quality carcase and growth',
      label: 'LEQ – improve worm resistance, EQ, carcase',
      id: SubIndex.ClSheddImprovingWorm,
      db: Database.LambplanShedders,
    },
    {
      value: 'MCP - Self replacing maternal flock',
      label: 'MCP - Self replacing maternal flock',
      id: SubIndex.ClSheddSelfReplacingMAT,
      db: Database.LambplanShedders,
    },
    {
      value: 'MCP+ - Self replacing maternal flock aimed to improve worm resistance and fleece weight',
      label: 'MCP+ – self replacing maternal improve worm resistance & fleece weight',
      id: SubIndex.ClSheddSelfReplacingWormMAT,
      db: Database.LambplanShedders,
    },
  ];

  return objectives.filter((o) => o.db === database);
};

/**
 * Gets the default user type from the menu items.
 * @param userType
 * @param userTypeItems
 */
export const getDefaultUserType = (userType: UserType, userTypeItems: CascadingMenuItem[]) => userTypeItems.find((u) => u.id === userType);

/**
 * Gets the default database from the menu items
 * @param database
 * @param databaseItems
 */
export const getDefaultDatabase = (database: Database, databaseItems: CascadingMenuItem[]) => {
  let db!: CascadingMenuItem;
  databaseItems.forEach((i) => {
    if (i.subOptions) {
      const found = i.subOptions.find((s) => s.id === database);
      if (found) {
        db = found;
      }
    } else if (i.id === database) {
      db = i;
    }
  });
  return db;
};

/**
 * Gets the default sub index (scenario) from the menu items.
 * @param subIndex
 * @param subIndexItems
 */
export const getDefaultSubIndex = (subIndex: SubIndex, subIndexItems: CascadingMenuItem[]) => subIndexItems.find((i) => i.id === subIndex);
